import type { FeatureContext } from '../../types';
import { KingdomGame } from './KingdomGame';

export function KingdomFeature(_: FeatureContext) {
  return <KingdomGame />;
}
